import { createSelector } from '@reduxjs/toolkit';

import { BANK_ACCOUNTS_CACHE_TIME } from '@/redux/modules/account/payments/bankAccount/bankAccount.types';
import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const getBankAccountSlice = createSelector(stateSelector, (state) => state.bankAccount);
const passthroughSelector = (_: GlobalState, id: number | string) => id;

export const getBankAccounts = createSelector(getBankAccountSlice, (slice) => slice.bankAccounts);
export const getBankAccountsLoading = createSelector(getBankAccountSlice, (slice) => slice.bankAccountsLoading);
export const getBankAccountsLoaded = createSelector(getBankAccountSlice, (slice) => slice.bankAccountsLoaded);

export const getDefaultBankAccount = createSelector(
    [getBankAccounts, passthroughSelector],
    (bankAccounts, providerId) =>
        bankAccounts?.find((bankAccount) => bankAccount.defaultAccount && bankAccount.providerId === providerId)
);

export const getPlaidLinkToken = createSelector(
    [getBankAccountSlice, passthroughSelector],
    (slice, id) => slice.plaidLinkTokens[id] ?? ''
);
export const getPlaidFetching = createSelector(getBankAccountSlice, (slice) => slice.plaidFetching);
export const getPlaidError = createSelector(getBankAccountSlice, (slice) => slice.plaidError);

export const shouldFetchBankAccounts = createSelector(
    getBankAccountsLoaded,
    getBankAccountsLoading,
    (loaded, loading) => {
        if (loading) {
            return false;
        }
        const time = Date.now();
        const diff = time - loaded;
        return !loaded || diff > BANK_ACCOUNTS_CACHE_TIME;
    }
);
